import "./styles.scss";

import { useState } from "react";
import classnames from "classnames";
import { AnimatePresence, motion } from "framer-motion";

const mainClass = "dashboard-website-overview";

const WebsiteOverview = ({ data }) => {
  const [activeTab, setActiveTab] = useState(0);

  const activeContent = data?.[activeTab];

  return (
    <div className={mainClass}>
      {data?.length > 1 && (
        <div className={`${mainClass}__tabs`}>
          {data.map((item, index) => (
            <button
              key={index}
              type="button"
              className={classnames({ active: activeTab === index })}
              onClick={() => setActiveTab(index)}
            >
              {item.title}
            </button>
          ))}
        </div>
      )}
      <div className={`${mainClass}__content`}>
        <AnimatePresence initial={false} mode="wait">
          {activeContent && (
            <motion.div
              key={activeTab}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ type: "tween", duration: 0.2 }}
            >
              {activeContent?.title && (
                <div className={`${mainClass}__header`}>
                  <div className={`${mainClass}__header__icon`}>
                    {activeContent.icon}
                  </div>
                  <div className={`${mainClass}__header__text`}>
                    <span>{activeContent.title}</span>
                    {activeContent?.description && (
                      <span>{activeContent.description}</span>
                    )}
                  </div>
                </div>
              )}
              {activeContent?.component ? (
                activeContent.component
              ) : (
                <div className={`${mainClass}__content__listing`}>
                  {activeContent?.content?.map((content, index) => (
                    <div
                      key={index}
                      className={`${mainClass}__content__listing__item`}
                    >
                      <span>{content.label}</span>
                      <span>{content.value}</span>
                    </div>
                  ))}
                </div>
              )}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default WebsiteOverview;
